import ArrayComponent from 'orionsoft-parts/lib/components/fields/ArrayComponent'
import Text from 'orionsoft-parts/lib/components/fields/Text'
import Textarea from 'orionsoft-parts/lib/components/fields/Textarea'
import NumberField from 'orionsoft-parts/lib/components/fields/numeral/Number'
import DateText from 'orionsoft-parts/lib/components/fields/DateText'
import Select from 'orionsoft-parts/lib/components/fields/Select'
import Checkbox from 'orionsoft-parts/lib/components/fields/Checkbox'
import ObjectField from './ObjectField'
import SixDigitInput from './SixDigitInput'
import Points from './Points'
import Phone from './Phone'
import DateTime from './DateTime'
import StringArray from './StringArray'
import Percentage from 'orionsoft-parts/lib/components/fields/numeral/Percentage'
import Periods from './Periods'
import Zone from './Zone'
import SmallSelect from './SmallSelect'
import File from './File'
import CountryCode from './CountryCode'
import Money from './Money'
import Password from './Password'
import Editor from './Editor'
import WebsitesIds from './WebsitesIds'
import Area from './Area'
import Rules from './Rules'
import ReleaseOrderValidations from './ReleaseOrderValidations'
import ZoneOfCountry from './ZoneOfCountry'
import TokenSmartCard from './TokenSmartCard'

export default {
  countryCode: CountryCode,
  string: Text,
  editor: Editor,
  password: Password,
  textarea: Textarea,
  percentage: Percentage,
  number: NumberField,
  array: ArrayComponent,
  plainObject: ObjectField,
  boolean: Checkbox,
  date: DateText,
  sixDigit: SixDigitInput,
  select: Select,
  points: Points,
  phone: Phone,
  datetime: DateTime,
  money: Money,
  '[string]': StringArray,
  periods: Periods,
  zone: Zone,
  zoneOfCountry: ZoneOfCountry,
  area: Area,
  smallSelect: SmallSelect,
  file: File,
  websites: WebsitesIds,
  distanceBonusRules: Rules,
  releaseOrderValidations: ReleaseOrderValidations,
  tokenSmartCard: TokenSmartCard
}
